import React, { useState } from "react"
import { Link, useSearchParams } from "react-router-dom"
import Header from "../../components/navigation/Header"
import Footer from "../../components/navigation/Footer"
import CreateCSFR from "../../hooks/userAuthentication/CreateCSFR"
import axios from "axios"
import ReCAPTCHA from "react-google-recaptcha"

export default function UpdatePassword(){
    const [captchaToken, setCaptchaToken] = useState<string | null>(null)
    const [invalidCaptcha, setInvalidCaptcha] = useState(true)
    const csrfToken = CreateCSFR({ name: "csrftoken" })
    const [password, setPassword] = useState<string>()
    const [confirmPassword, setConfirmPassword] = useState<string>()
    const [submitted, setSubmitted] = useState<boolean>(false)
    const [queryParameters] = useSearchParams()

    const handleCaptchaChange = (value: string | null) => {
        if (value) {
            setCaptchaToken(value)
            setInvalidCaptcha(false)

            axios.post(`${process.env.REACT_APP_SKILLJA_URL}/verify_captcha/`, { token: value }, {
                headers: { 'X-CSRFToken': csrfToken, 'Content-Type': 'application/json' },
                withCredentials: true,
            })
            .then(res => setInvalidCaptcha(!res.data.success))
            .catch(() => setInvalidCaptcha(true))
        } 
        else {
            setInvalidCaptcha(true)
        }
    }

    function submitPasswordReset(){
        const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).{10,}$/

        if (!password || !confirmPassword) {
            alert("Please fill both fields")
            return
        }

        if (password !== confirmPassword) {
            alert("Passwords do not match")
            return
        }

        if (!passwordRegex.test(password)) {
            alert("Password must be at least 10 characters and include a number")
            return
        }

        // Get the token from URL
        const token = queryParameters.get("token")

        axios.post(`${process.env.REACT_APP_SKILLJA_URL}/update_password/`, { password: confirmPassword, token: token}, {
            headers: { 'X-CSRFToken': csrfToken, 'Content-Type': 'application/json' },
            withCredentials: true,
        })
        .then(() => setSubmitted(true))
        .catch(() => {
            setSubmitted(false)
            alert('Oops! Something went wrong. Please try again.')
        })
        
    }

    return (
        <div>
            <Header useCase="onboarding"/>
            <div className="text-center mx-auto mb-52 font-kulim">
                <h1 className="text-center mx-auto font-semibold text-3xl mt-10 mb-16">
                    Update Your Password
                </h1>
                <form 
                    className="m-auto w-80"
                    onSubmit={(e) => {
                        e.preventDefault()
                        submitPasswordReset()
                    }}
                >
                    <input 
                        type="text" 
                        placeholder="Enter new password"
                        className="form-input px-3 mb-4"
                        onChange={(e)=>setPassword(e.target.value)}
                    />
                    <input 
                        type="text" 
                        placeholder="Confirm password"
                        className="form-input px-3"
                        onChange={(e)=>setConfirmPassword(e.target.value)}
                    />
                    {!submitted ?
                        (invalidCaptcha ?
                            <div className="mt-5 mb-3 recaptcha-container">
                                {invalidCaptcha && process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY && (
                                    <ReCAPTCHA
                                        onChange={handleCaptchaChange}
                                        sitekey={process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY!}
                                        onExpired={() => setCaptchaToken(null)}
                                    />
                                )}
                            </div>
                        :
                            <button
                                className={`form-btn px-4 py-1.5 mt-10 ${invalidCaptcha && 'cursor-not-allowed'}`}
                                disabled={invalidCaptcha}
                            >
                                Update Password
                            </button>
                        )
                    :
                        <div className="flex-col mt-12">
                            <p className="text-center mx-auto">
                                Your password has been updated!
                            </p>
                            <div className="border border-main-grey-300 w-24 mx-auto mt-4 mb-3"></div>
                            <Link to={'/login'} className="underline text-main-green-700 font-semibold cursor-pointer text-center mx-auto hover:text-main-green-500">
                                Login
                            </Link>
                        </div>
                    }
                </form>
            </div>
        </div>
    )
}